import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Auth\TwoFactorChallengeController::login
* @see app/Http/Controllers/Admin/Auth/TwoFactorChallengeController.php:19
* @route '/two-factor-challenge'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

login.definition = {
    methods: ["get","head"],
    url: '/two-factor-challenge',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Auth\TwoFactorChallengeController::login
* @see app/Http/Controllers/Admin/Auth/TwoFactorChallengeController.php:19
* @route '/two-factor-challenge'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Auth\TwoFactorChallengeController::login
* @see app/Http/Controllers/Admin/Auth/TwoFactorChallengeController.php:19
* @route '/two-factor-challenge'
*/
login.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Auth\TwoFactorChallengeController::login
* @see app/Http/Controllers/Admin/Auth/TwoFactorChallengeController.php:19
* @route '/two-factor-challenge'
*/
login.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: login.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Auth\TwoFactorChallengeController::login
* @see app/Http/Controllers/Admin/Auth/TwoFactorChallengeController.php:19
* @route '/two-factor-challenge'
*/
const loginForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Auth\TwoFactorChallengeController::login
* @see app/Http/Controllers/Admin/Auth/TwoFactorChallengeController.php:19
* @route '/two-factor-challenge'
*/
loginForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Auth\TwoFactorChallengeController::login
* @see app/Http/Controllers/Admin/Auth/TwoFactorChallengeController.php:19
* @route '/two-factor-challenge'
*/
loginForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

login.form = loginForm

const twoFactor = {
    login: Object.assign(login, login),
}

export default twoFactor